import { createSelector } from 'reselect';
import { FAVORITES_DISHES_SECTION_ID } from '@shopDetails/constants';
import getMenuWithDiscounts from './getMenuWithDiscounts';

function getProductsWithCustomPhoto(sections) {
  return sections
    ?.reduce((acc, section) => {
      const { products, id } = section;
      if (products.length && id !== FAVORITES_DISHES_SECTION_ID) {
        acc.push(...products.filter(p => p.hasCustomPhoto));
      }
      return acc;
    }, [])
    .filter(
      (element, idx, arr) =>
        arr.findIndex(item => item.id === element.id) === idx,
    );
}

const getHighlightedProducts = createSelector(getMenuWithDiscounts, menu => {
  if (menu) {
    const { sections } = menu;
    const hasSearchSection = sections?.some(s => s.id === 0);
    if (sections.length && !hasSearchSection) {
      return getProductsWithCustomPhoto(sections);
    }
  }
  return [];
});

export default getHighlightedProducts;
